import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "table__header" }
const _hoisted_3 = { class: "table__row" }
const _hoisted_4 = {
  key: 0,
  class: "table__cell"
}
const _hoisted_5 = {
  key: 0,
  class: "table__body"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "table__cell"
}

export type TableBaseColumn = {
  name: string; // key of the item property
  title?: string; // label to display in the table header
  isImportant?: boolean;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'TableBase',
  props: {
    columns: {},
    items: {},
    isClickable: { type: Boolean }
  },
  emits: ["selectItem"],
  setup(__props: any) {





const additionalClassName = (
  value?: null | string | Record<string, string>,
) => {
  if (!value) return {};
  if (typeof value === "string" || value instanceof String) return {};
  const { className } = value;
  if (className) return className;
  return {};
};
const displayedValue = (value?: null | string | Record<string, string>) => {
  if (!value || typeof value === "string" || value instanceof String)
    return value;
  return value.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
          return (_openBlock(), _createElementBlock("th", {
            class: "table__cell",
            key: column.name
          }, _toDisplayString(column.title), 1))
        }), 128)),
        (_ctx.$slots.actions)
          ? (_openBlock(), _createElementBlock("th", _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.items.length)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: _normalizeClass(['table__row', { 'table__row--clickable': __props.isClickable }]),
              key: item.id,
              onClick: ($event: any) => (_ctx.$emit('selectItem', item.id))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: _normalizeClass([
            'table__cell',
            {
              'table__cell--bold': column.isImportant,
            },
            additionalClassName(item[column.name]),
          ]),
                  key: column.name
                }, _toDisplayString(displayedValue(item[column.name])), 3))
              }), 128)),
              (_ctx.$slots.actions)
                ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "actions", { item: item })
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})